import { GameConstants } from "./../../../GameConstants";
import { BetButtons } from "./BetButtons";
import { Button } from "../../../utils/Button";
import { RoomManager } from "../../../managers/RoomManager";
import { GameVars } from "../../../GameVars";
import { AudioManager } from "../../../managers/AudioManager";

export class Slider extends Phaser.GameObjects.Container {

    public sliderWidth: number;
    
    private betButtons: BetButtons;
    private btnSlider: Phaser.GameObjects.Image;

    private min: number;
    private max: number;

    private slide: boolean;

    constructor(scene: Phaser.Scene, betButtons: BetButtons) {

        super(scene);

        this.x = 460;
        this.y = -50;

        this.betButtons = betButtons;

        this.slide = false;

        const bckLeft = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "bet_bar_left.png");
        bckLeft.setOrigin(0, .5);
        this.add(bckLeft);

        const bckRight = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "bet_bar_right.png");
        bckRight.setOrigin(0, .5);
        this.add(bckRight);

        let bckWidth = (GameConstants.GAME_WIDTH - (400 + bckLeft.width + bckRight.width + 10) * GameVars.scaleX) / GameVars.scaleX;
        bckWidth = bckWidth > 550 ? 550 : bckWidth;

        let bckTile = new Phaser.GameObjects.Image(this.scene, bckLeft.x + bckLeft.width, 0, "texture_atlas_1", "bet_bar_tile.png");

        
        for (let i = 0; i < Math.floor(bckWidth / bckTile.width); i++) {
            bckTile = new Phaser.GameObjects.Image(this.scene, bckLeft.x + bckLeft.width + bckTile.width * i, 0, "texture_atlas_1", "bet_bar_tile.png");
            bckTile.setOrigin(0, .5);

            this.add(bckTile);
            
        }

        let tileWidthAux = Math.floor(bckWidth / bckTile.width) * bckTile.width;
        
        bckRight.x = bckTile.x + (bckTile.width * bckTile.scaleX);
        this.sliderWidth = tileWidthAux + bckLeft.width + bckRight.width;

        bckTile.setInteractive(new Phaser.Geom.Rectangle(-tileWidthAux, 0, tileWidthAux + 20, bckTile.height), Phaser.Geom.Rectangle.Contains);
        bckTile.on("pointerdown", () => {
            this.onSliderDown();
        }, this);
        bckTile.on("pointerup", () => {
            this.onSliderUp();
        }, this);
        bckTile.on("pointerout", () => {
            this.onSliderUp();
        }, this);

        const minusButton = new Button(this.scene, 122, 0, "texture_atlas_1", "btn_less.png", "btn_less.png", true);
        minusButton.onDown(this.onClickMinus, this);
        this.add(minusButton);

        const plusButton = new Button(this.scene, bckRight.x + 20, 0, "texture_atlas_1", "btn_more.png", "btn_more.png", true);
        plusButton.onDown(this.onClickPlus, this);
        this.add(plusButton);

        this.min = bckLeft.x + bckLeft.width + 60; 
        this.max = bckLeft.x + bckLeft.width + tileWidthAux - 32;

        this.btnSlider = new Phaser.GameObjects.Image(this.scene, bckLeft.x + bckLeft.width + tileWidthAux / 2, 0, "texture_atlas_1", "btn_slider.png");
        // this.btnSlider.setInteractive();
        // this.btnSlider.on("pointerdown", () => {
        //     this.onSliderDown();
        // }, this);

        // this.btnSlider.on("pointerup", () => {
        //     this.onSliderUp();
        // }, this);

        // this.btnSlider.on("pointerout", () => {
        //     this.onSliderUp();
        // }, this);

        this.add(this.btnSlider);

        this.scene.sys.updateList.add(this);
    }

    public preUpdate(): void {

        if (this.slide) {

            this.btnSlider.x = (this.scene.input.activePointer.x - this.parentContainer.x) / GameVars.scaleX - this.x;

            if (this.btnSlider.x < this.min) {
                this.btnSlider.x = this.min;
            } else if (this.btnSlider.x > this.max) {
                this.btnSlider.x = this.max;
            }

            this.setBetValue();
        }
    }

    public setBetValue(): void {

        let value = this.btnSlider.x - this.min;

        let bet = this.valueToBet(value);
        bet = Math.ceil(bet / 5) * 5;

        this.betButtons.setBetValue(bet);
    }

    public toMinimum(): void {
        this.btnSlider.x = this.min;

        this.setBetValue();
    }

    private onClickMinus(): void {

        AudioManager.playSound("btn_click");

        let max = RoomManager.getPlayer(GameVars.playerId).chips;
        let min = Math.min(max, GameVars.gameState.raise);

        let dist = this.max - this.min;
        let value = max - min;

        let newValue = (dist * 5) / value;


        this.btnSlider.x -= newValue;

        if (this.btnSlider.x < this.min) {
            this.btnSlider.x = this.min;
        }

        this.setBetValue();
    }

    private onClickPlus(): void {

        AudioManager.playSound("btn_click");

        let max = RoomManager.getPlayer(GameVars.playerId).chips;
        let min = Math.min(max, GameVars.gameState.raise);
        
        let dist = this.max - this.min;
        let value = max - min;

        let newValue = (dist * 5) / value;

        this.btnSlider.x += newValue;

        if (this.btnSlider.x > this.max) {
            this.btnSlider.x = this.max;
        }

        this.setBetValue();
    }

    private onSliderDown(): void {

        AudioManager.playSound("btn_click");

        this.slide = true;
    }

    private onSliderUp(): void {

        this.slide = false;
    }

    private betToValue(bet: number): number {

        let max = RoomManager.getPlayer(GameVars.playerId).chips;
        let min = Math.min(max, GameVars.gameState.raise);

        return this.min + ((this.max - this.min) * bet) / (max - min);
    }

    private valueToBet(value: number): number {

        let max = RoomManager.getPlayer(GameVars.playerId).chips;
        let min = Math.min(max, GameVars.gameState.raise);

        return Math.round(min + ((max - min) * value) / (this.max - this.min));
    }
}
